<template>
  <section
    class="features-split section"
    :class="[
      topOuterDivider && 'has-top-divider',
      bottomOuterDivider && 'has-bottom-divider',
      hasBgColor && 'has-bg-color',
      invertColor && 'invert-color',
    ]"
  >
    <div class="container">
      <div
        class="features-split-inner section-inner"
        :class="[
          topDivider && 'has-top-divider',
          bottomDivider && 'has-bottom-divider',
        ]"
      >
        <c-section-header :data="sectionHeader" class="center-content" />
        <div
          class="split-wrap"
          :class="[
            invertMobile && 'invert-mobile',
            invertDesktop && 'invert-desktop',
            alignTop && 'align-top',
          ]"
        >
          <div class="split-item reveal-scale-up">
            <div class="split-item-content center-content-mobile">
              <h3 class="mt-0 mb-16">Easy to use</h3>
              <p class="m-0">
                All you need is a free TradingView account. Then just add our
                premium indicator to your TradingView Chart. It works on any
                device on any market.
              </p>
            </div>
            <div
              class="split-item-image is-3d illustration-element-03"
              :class="imageFill && 'split-item-image-fill'"
            >
              <c-image
                :src="require('@/assets/images/feature-split-01.png')"
                alt="SmartAlgo Mobile"
                :width="528"
                :height="396"
              />
            </div>
          </div>

          <div class="split-item reveal-scale-up">
            <div class="split-item-content center-content-mobile">
              <h3 class="mt-0 mb-16">Get alerts directly to your phone</h3>
              <p class="m-0">
                Receive instant alerts with your buy and sell signals directly
                in the TradingView mobile app and in your browser. You can also
                receive alerts by Email, SMS, and Webhook.
              </p>
            </div>
            <div
              class="split-item-image is-3d illustration-element-04"
              :class="imageFill && 'split-item-image-fill'"
            >
              <c-image
                :src="require('@/assets/images/feature-split-02.jpg')"
                alt="SmartAlgo Mobile Alerts"
                :width="528"
                :height="396"
              />
            </div>
          </div>

          <div class="split-item reveal-scale-up">
            <div class="split-item-content center-content-mobile">
              <h3 class="mt-0 mb-16">Lifetime Updates and Live Support</h3>
              <p class="m-0">
                Rest easy knowing our quants are constantly updating the
                algorithm to ensure the best performance across all asset
                classes. Receive live support on our Discord server.
              </p>
            </div>
            <div
              class="split-item-image is-3d illustration-element-05"
              :class="imageFill && 'split-item-image-fill'"
            >
              <c-image
                :src="require('@/assets/images/feature-split-03.jpg')"
                alt="Online support through"
                :width="528"
                :height="396"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { SectionSplitProps } from "@/utils/SectionProps.js";
import CSectionHeader from "@/components/sections/partials/SectionHeader.vue";
import CImage from "@/components/elements/Image.vue";

export default {
  name: "CFeaturesSplit",
  components: {
    CSectionHeader,
    CImage,
  },
  mixins: [SectionSplitProps],
  data() {
    return {
      sectionHeader: {
        title: "Why choose SmartAlgo?",
        paragraph:
          "Our propietary algorithm gives high probability signals. It works for Crypto, Stocks, Forex, and ETFs.",
      },
    };
  },
};
</script>